var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZonasSanitarias(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.9997 91.6667C74.9997 98.2971 77.6336 104.656 82.322 109.344C87.0104 114.033 93.3693 116.667 99.9997 116.667C106.63 116.667 112.989 114.033 117.677 109.344C122.366 104.656 125 98.2971 125 91.6667C125 85.0363 122.366 78.6774 117.677 73.989C112.989 69.3006 106.63 66.6667 99.9997 66.6667C93.3693 66.6667 87.0104 69.3006 82.322 73.989C77.6336 78.6774 74.9997 85.0363 74.9997 91.6667Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.141 138.808L111.783 174.167C108.658 177.289 104.421 179.042 100.004 179.042C95.5865 179.042 91.3498 177.289 88.2247 174.167L52.858 138.808C43.5349 129.485 37.1858 117.606 34.6138 104.674C32.0417 91.7419 33.3621 78.3376 38.4081 66.1561C43.454 53.9745 51.9988 43.5628 62.962 36.2376C73.9253 28.9123 86.8144 25.0024 99.9997 25.0024C113.185 25.0024 126.074 28.9123 137.037 36.2376C148.001 43.5628 156.545 53.9745 161.591 66.1561C166.637 78.3376 167.958 91.7419 165.386 104.674C162.814 117.606 156.465 129.485 147.141 138.808Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZonasSanitarias);
export default __webpack_public_path__ + "static/media/ZonasSanitarias.1df05915be156288da0ede9ba6f04e69.svg";
export { ForwardRef as ReactComponent };